/**
 * Weird fix to fix currency values
 * @param  {string} value The currency value -> ie. $10,000.58
 * @return {number}       10000.58
 */
export function fixCurrencyValue(value: any): number {
	if (!value) {
		return 0;
	}

	const cleanedValue = value
		.toString()
		.trim()
		.replace(/[^\d.,'\s]/g, '');
	const parts = cleanedValue.split(/\s+/);

	// Handle space separated decimals like 12.345 015. Convert to 12345.015
	if (parts.length === 2 && /^\d+$/.test(parts[1])) {
		// Check if the second part is only digits
		const integerPart = parts[0].replace(/\D/g, '');
		const decimalPart = parts[1];

		return parseFloat(`${integerPart}.${decimalPart}`);
	}

	// Check if the value is in european format like 12.345,56
	const europeanFormat =
		/,\d{1,3}$/.test(cleanedValue) ||
		(cleanedValue.includes(',') &&
			(cleanedValue.match(/\./g) || []).length > 1);

	const normalizedValue = europeanFormat
		? cleanedValue.replace(/[.\s']/g, '').replace(',', '.')
		: cleanedValue.replace(/[, ']/g, '');

	const parsedValue = parseFloat(normalizedValue);

	return isNaN(parsedValue) ? 0 : parsedValue;
}

/**
 * Formats the pay rate string so that fixCurrencyValue can make proper calculation
 * USD only
 * @param {string} value
 * @param {string} currencySymbol
 * @return {string}
 */
export function appendDecimalIfNecessary(
	value: string,
	currencySymbol = '$',
): string {
	if (currencySymbol !== '$') {
		return value;
	}

	const match = /^(\d*,*\d*)(\.(\d*)){0,1}$/.exec(
		value.replace(currencySymbol, ''),
	);
	if (match) {
		if (match[3] && match[3].length === 2) {
			return value;
		}
		if (!match[2]) {
			return `${value}.00`;
		}
		if (match[2].length === 1) {
			return `${value}00`;
		}
		if (match[3].length === 1) {
			return `${value}0`;
		}
	}
	return value;
}
